/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OutstandingSection14FeeRenegotiations } from './OutstandingSection14FeeRenegotiations';
import {
    OutstandingSection14FeeRenegotiationsFromJSON,
    OutstandingSection14FeeRenegotiationsFromJSONTyped,
    OutstandingSection14FeeRenegotiationsToJSON,
} from './OutstandingSection14FeeRenegotiations';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfOutstandingSection14FeeRenegotiations
 */
export interface ResultOfOutstandingSection14FeeRenegotiations {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {OutstandingSection14FeeRenegotiations}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    data?: OutstandingSection14FeeRenegotiations;
    /**
     * 
     * @type {number}
     * @memberof ResultOfOutstandingSection14FeeRenegotiations
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfOutstandingSection14FeeRenegotiations interface.
 */
export function instanceOfResultOfOutstandingSection14FeeRenegotiations(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfOutstandingSection14FeeRenegotiationsFromJSON(json: any): ResultOfOutstandingSection14FeeRenegotiations {
    return ResultOfOutstandingSection14FeeRenegotiationsFromJSONTyped(json, false);
}

export function ResultOfOutstandingSection14FeeRenegotiationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfOutstandingSection14FeeRenegotiations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : OutstandingSection14FeeRenegotiationsFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfOutstandingSection14FeeRenegotiationsToJSON(value?: ResultOfOutstandingSection14FeeRenegotiations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': OutstandingSection14FeeRenegotiationsToJSON(value.data),
        'Count': value.count,
    };
}

